import { Injectable } from '@angular/core';
import { DhProfileConfig, DhProfileCourse, DhProfileLanding } from '../interfaces/dh-profile-config';
import { ApiService } from './api.service';

export interface DhProfileConfigSummary {
  level: number;
  exists: boolean;
  version?: number | null;
  items_count?: number;
  competences_count?: number;
  combinations_count?: number;
  options_count?: number;
  landing_enabled?: boolean;
  updated_at?: string;
  error?: string;
}

export interface DhProfileLandingSummary {
  level: number;
  landing: DhProfileLanding;
}

export interface DhProfilePublicConfig {
  level: number;
  landing: DhProfileLanding | null;
  course: DhProfileCourse | null;
}

const COMPETENCES_LABEL_KEY_BY_LEVEL: Record<number, string> = {
  0: 'admin:dh_profiles:competences_label:level_0',
  1: 'admin:dh_profiles:competences_label:level_1',
  2: 'admin:dh_profiles:competences_label:level_2',
  3: 'admin:dh_profiles:competences_label:level_3',
  4: 'admin:dh_profiles:competences_label:level_4',
  5: 'admin:dh_profiles:competences_label:level_5',
  6: 'admin:dh_profiles:competences_label:level_6',
  7: 'admin:dh_profiles:competences_label:level_7',
};

export function competencesLabelKey(level: number | null | undefined): string {
  if (level === null || level === undefined) return 'admin:dh_profiles:tab:competences';
  return COMPETENCES_LABEL_KEY_BY_LEVEL[level] || 'admin:dh_profiles:tab:competences';
}

@Injectable({ providedIn: 'root' })
export class DhProfileConfigService {
  constructor(private api: ApiService) {}

  list(): Promise<DhProfileConfigSummary[]> {
    return this.api.get('/dh_profile/config').then((resp: any) => {
      return (resp && resp.data ? resp.data : resp) as DhProfileConfigSummary[];
    });
  }

  /**
   * Public endpoint (no auth required). Returns landing info for every level
   * with landing.enabled = true.
   */
  listPublicLandings(): Promise<DhProfileLandingSummary[]> {
    return this.api.get('/dh_profile/landings').then((resp: any) => {
      return (resp && resp.data ? resp.data : resp) as DhProfileLandingSummary[];
    });
  }

  getPublicConfig(level: number): Promise<DhProfilePublicConfig> {
    return this.api.get(`/dh_profile/public/${level}`).then((resp: any) => {
      return (resp && resp.data ? resp.data : resp) as DhProfilePublicConfig;
    });
  }

  get(level: number): Promise<DhProfileConfig> {
    return this.api.get(`/dh_profile/config/${level}`).then((resp: any) => {
      return (resp && resp.data ? resp.data : resp) as DhProfileConfig;
    });
  }

  save(level: number, config: DhProfileConfig): Promise<any> {
    return this.api.put(`/dh_profile/config/${level}`, config);
  }

  uploadPoster(level: number, comb: string, file: File): Promise<{ filename: string; url: string }> {
    const form = new FormData();
    form.append('file', file);
    form.append('comb', comb);
    return this.api
      .postFile(`/dh_profile/config/${level}/upload-poster`, form)
      .then((resp: any) => (resp && resp.data ? resp.data : resp));
  }
}
